// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import moment from 'moment';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import ImportedBookingService from 'services/ImportedBookingService';
import BootboxHelper from 'helpers/BootboxHelper';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';

//-------------------------------------------------------------------------------------------------------------------

class ImportedBookingsPage extends React.Component {

    constructor(props) {
        super(props);

        this.editBookingModalRef = React.createRef();

        this.state = {
            isLoading: true
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        GlobalStateService.setValues({
            area: 'imported-bookings'
        });
        this.load();
    }

    async load() {
        this.setState({
            isLoading: true
        });
        const importedBookings = await ImportedBookingService.listPending();
        this.setState({
            importedBookings,
            isLoading: false
        });
    }

    async confirmGetLatestEmails() {
        const confirm = await BootboxHelper.confirm('Get latest emails now? (Note that this happens once per day automatically)');
        if (confirm) {
            if (this.state.isGettingEmails) {
                return;
            }
            this.setState({ isGettingEmails: true });
            await ImportedBookingService.getGrimsbyBookingEmails();
            this.setState({ isGettingEmails: false });
            this.load();
        }
    }

    async confirmIgnore(id) {
        const confirm = await BootboxHelper.confirm('Ignore this booking and remove it from the list?');
        if (confirm) {
            await ImportedBookingService.ignore(id);
            this.load();
        }
    }

    async addNewBooking(id) {
        const booking = await ImportedBookingService.getFullInfo(id);
        booking.status = 'Active';
        await this.editBookingModalRef.current.show({
            ...booking
        });
        this.load();
    }

    render() {
        const {
            isLoading
        } = this.state;

        return (
            <div className="page imported-bookings-page">
                
                <PageHeader>
                    <h1>Imported Bookings</h1>
                </PageHeader>

                <main>

                    <Container>
                        
                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>
        );
    }

    renderInner() {
        const {
            isLoading,
            importedBookings,
            isGettingEmails
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <div style={{ display: 'flex' }} className="mb-3">

                <button type="button" className="btn btn-primary me-auto" onClick={() => this.confirmGetLatestEmails()}>
                    {isGettingEmails ? <Loader isInline /> : <span className="fa-solid fa-sync-alt" />}
                    {' '}Get new emails from GRIMSBY
                </button>

                <a href="/api/email/connect" className="btn btn-secondary ms-auto">
                    Connect to email account
                </a>

            </div>

            <table className="table table-bordered imported-bookings-table">
                <thead>
                    <tr>
                        <th className="date-col">Date</th>
                        <th className="subject-col">Type / Subject</th>
                        <th className="fields-col">Fields</th>
                        <th className="actions-col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {importedBookings.map(ib =>
                        <tr key={ib.id}>
                            <td className="date-col">
                                {moment(ib.dateAdded).format('DD/MM/YYYY')}
                            </td>
                            <td className="subject-col">
                                <div className="email-type">{ib.emailType}</div>
                                {ib.title}
                            </td>
                            <td className="fields-col">
                                <div className="imported-booking-fields">
                                    {Object.keys(ib.fields).map(ibf =>
                                        <div key={ibf} className="imported-booking-field">
                                            <div className="imported-booking-field-name">
                                                {ibf}
                                            </div>
                                            <div className="imported-booking-field-value">
                                                {ib.fields[ibf]}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td className="actions-col">

                                {this.renderActionsCol(ib)}

                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

        </>);
    }

    renderActionsCol(ib) {
        const contentParts = [
            <button type="button" className="btn btn-secondary w-100" onClick={() => this.confirmIgnore(ib.id)}>
                Ignore
            </button>
        ];

        switch (ib.emailType) {
            case 'Booking':
                contentParts.push(
                    <button type="button" className="btn btn-secondary w-100 mt-3" onClick={() => this.addNewBooking(ib.id)}>
                        Add new booking
                    </button>
                );
                if (ib.existingBooking) {
                    contentParts.push(
                        <div className="alert alert-danger mt-3">
                            <button className="btn btn-secondary btn-sm" onClick={async () => {
                                await this.editBookingModalRef.current.show({
                                    bookingID: ib.existingBooking.id
                                });
                                this.load();
                            }}>
                                <span className="fa-solid fa-search" />
                            </button>{' '}
                            Booking already exists ({ib.existingBooking.status})
                        </div>
                    );
                }
                break;
            case 'Cancellation':
                if (ib.existingBooking) {
                    contentParts.push(
                        <button className="btn btn-secondary btn-sm mt-3" onClick={async () => {
                            await this.editBookingModalRef.current.show({
                                bookingID: ib.existingBooking.id,
                                status: 'Cancelled',
                                dateCancelled: ib.dateAdded,
                                importedBookingID: ib.id
                            });
                            this.load();
                        }}>
                            <span className="fa-solid fa-search" />{' '}
                            Open booking ({ib.existingBooking.lmsid})
                        </button>
                    );
                } else {
                    contentParts.push(
                        <div className="alert alert-danger mt-3">
                            No booking found with this LMS ID
                        </div>
                    );
                }
                break;
        }

        return contentParts.map((cp, index) =>
            <React.Fragment key={index}>{cp}</React.Fragment>
        );
    }
}

export default withRouter(ImportedBookingsPage);